// extracted by mini-css-extract-plugin
export default {"delete_acount":"DeleteAcountPopup_delete_acount__DmWpk","header":"DeleteAcountPopup_header__S+LXA","cancel":"DeleteAcountPopup_cancel__XoZI4","link":"DeleteAcountPopup_link__wUNEJ"};